// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21-Hh","colMin":"styles_colMin__2C7BJ"};